import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface SkipRekeyInput {
    orderId: string;
}

const skipRekey = async (data: SkipRekeyInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/rekey/skip`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useSkipRekey = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: SkipRekeyInput) => skipRekey(data, sessionContext?.sessionId ?? null),
    });
};
